export const LANDING = "/";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const ACCOUNT = "/account";
export const ADMIN_SUPER = "/adminSuper";
export const ADMIN = "/admin";
export const HOME = "/home";
